const priceHelperUtils = {
  getPriceInDollars(currency, amount) {
    let amountToShow;
    switch (currency) {
      case 'JPY':
      case 'jpy':
      case '¥':
        amountToShow = amount;
        break;
      default:
        amountToShow = (amount / 100).toFixed(2);
    }
    return amountToShow;
  },
};

export default priceHelperUtils;
